import React from "react";

const ButtonLoader = ({ style = {} }) => (
  <div style={style} className="btn-loader">
    <i className="fa fa-spinner fa-spin" />
  </div>
);

export default ButtonLoader;
